import { ORDER_STATUS_LABELS } from "@/lib/api";

const TONE = {
  recommended: "bg-blue-50 text-blue-800 border-blue-200",
  ordered: "bg-amber-50 text-amber-800 border-amber-200",
  sample_collected: "bg-indigo-50 text-indigo-800 border-indigo-200",
  result_ready: "bg-emerald-50 text-emerald-800 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
};

export function OrderStatusChip({ status }) {
  return <span data-testid={`order-status-${status}`} className={`badge-pill ${TONE[status] || TONE.recommended}`}>{ORDER_STATUS_LABELS[status] || status}</span>;
}
